<div class="ss-price">
  <span class="ss-price-sign">$</span>
  <span class="ss-price-int">{{intPart}}</span>
  <span class="ss-price-side" *ngIf="decPart">
    <span class="ss-price-dec" *ngIf="showDecimal">.{{decPart}}</span>
    <span class="ss-price-period" *ngIf="period">/{{period}}</span>
  </span>
</div>
